module.exports = __webpack_public_path__ + "static/media/logo.f5ffc46d.png";